import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ResponsiveMenuContent from "./ResponsiveMenuContent.js";

const InlineMainMenu = ({ setMobileMenuProfileDrawer, toggleMobileMenu }) => {

  return (
    <ResponsiveMenuContent setMobileMenuProfileDrawer={setMobileMenuProfileDrawer} />
    
  );
};

export default InlineMainMenu;
